// extracted by mini-css-extract-plugin
export var button = "ClubInfo-module--button--JRRjV";
export var content = "ClubInfo-module--content--L2vF1";
export var greenTheme = "ClubInfo-module--greenTheme--visq2";
export var label = "ClubInfo-module--label--cnFGE";
export var roseTheme = "ClubInfo-module--roseTheme--YX6MX";
export var title = "ClubInfo-module--title--fxwmZ";
export var wrapper = "ClubInfo-module--wrapper--Zt0MX";